import { DISTRIBUTION_WAY } from '@/features/Distribution/types';
import type { CompanyDistributionSettings } from '@/features/Distribution/types';

export const buildEmptyDistributionSettings =
  (): CompanyDistributionSettings => ({
    channels: [],
    pools: [],
    selection: {
      channel: null,
      pool: null,
      method: DISTRIBUTION_WAY.USE_POOL,
    },
  });
